import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

interface IComponentProps {
    name: string;
    head: string[];
    body: string[];
}

const QueryResultTable = (props: IComponentProps) => {
    return (
        <div style={{ marginTop: 32 }}>
            <h5>{props.name}</h5>
            <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            {props.head.map((h) => (
                                <TableCell key={h} style={{ width: 200 }}>
                                    {h}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.body.map((entry: any, index: number) => (
                            <TableRow key={index} hover>
                                {props.head.map((h: string, i: number) => (
                                    <TableCell key={i} style={{ width: "fit-content" }}>
                                        {entry[h].value}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default QueryResultTable;
